import React from "react"
import { Button, Card, Col, Input, Label, Row, Table } from "reactstrap"
import { useSelector } from "react-redux"
import ScrollBar from "react-perfect-scrollbar"
import TextInput from "components/Common/TextInput"
import "./style.css"
import SelectBox from "components/Common/SelectBox"
import Flatpickr from "react-flatpickr"

function Repiar(props) {
  const store = useSelector(state => state)
  const form = store.inspection.orderSize.data?.repair
  console.log(form)

  if (!form) return null

  return (
    <Card body>
      <ScrollBar style={{ height: 585, position: "relative" }}>
        <Row>
          <Col md="12">
            <div className="mt-5">
              <h3>トラウザーズ</h3>
              <Table responsive style={{ whiteSpace: "nowrap" }}>
                <thead>
                  <tr>
                    <th>トラウザーズ</th>
                    <th>調整(cm)</th>
                    <th></th>
                    <th colSpan={2}>上がり（cm）</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ width: 150 }}>ウエスト</td>
                    <td style={{ width: 150 }}>
                      <TextInput
                        value={form.pantsWaistAdjustment || ""}
                        readOnly
                        name="pantsWaistAdjustment"
                      />
                    </td>
                    <td>
                      <Input
                        name={"pantsWaist"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.pantsWaist}
                        defaultChecked={form.pantsWaist === "つめ"}
                      />
                      <Label>つめ</Label>
                      <Input
                        name={"pantsWaist"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.pantsWaist}
                        defaultChecked={form.pantsWaist === "出し"}
                      />
                      <Label>出し</Label>
                    </td>
                    <td style={{ width: 55 }}></td>
                    <td style={{ width: 150 }}>
                      <TextInput
                        value={form.pantsWaistRise || ""}
                        readOnly
                        name="pantsWaistRise"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>ヒップ</td>
                    <td>
                      <TextInput
                        value={form.hipAdjustment || ""}
                        readOnly
                        name="hipAdjustment"
                      />
                    </td>

                    <td>
                      <Input
                        name={"hip"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.hip}
                        defaultChecked={form.hip === "つめ"}
                      />
                      <Label>つめ</Label>
                      <Input
                        name={"hip"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.hip}
                        defaultChecked={form.hip === "出し"}
                      />
                      <Label>出し</Label>
                    </td>
                    <td style={{ width: 55 }}></td>
                    <td>
                      <TextInput
                        value={form.hipRise || ""}
                        readOnly
                        name="hipRise"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>尻先</td>
                    <td>
                      <TextInput
                        value={form.buttocksAdjustment || ""}
                        readOnly
                        name="buttocksAdjustment"
                      />
                    </td>

                    <td>
                      <Input
                        name={"buttocks"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.buttocks}
                        defaultChecked={form.buttocks === "つめ"}
                      />
                      <Label>つめ</Label>
                      <Input
                        name={"buttocks"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.buttocks}
                        defaultChecked={form.buttocks === "出し"}
                      />
                      <Label>出し</Label>
                    </td>
                    <td style={{ width: 55 }}></td>
                    <td>
                      <TextInput
                        value={form.buttocksRise || ""}
                        readOnly
                        name="buttocksRise"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>股下</td>
                    <td>
                      <TextInput
                        value={form.inseamAdjustment || ""}
                        readOnly
                        name="inseamAdjustment"
                      />
                    </td>

                    <td>
                      <Input
                        name={"inseam"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.inseam}
                        defaultChecked={form.inseam === "つめ"}
                      />
                      <Label>つめ</Label>
                      <Input
                        name={"inseam"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.inseam}
                        defaultChecked={form.inseam === "出し"}
                      />
                      <Label>出し</Label>
                    </td>
                    <td style={{ width: 55 }}></td>
                    <td>
                      <TextInput
                        value={form.inseamRise || ""}
                        readOnly
                        name="inseamRise"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>裾口</td>
                    <td>
                      <TextInput
                        value={form.cuffAdjustment || ""}
                        readOnly
                        name="cuffAdjustment"
                      />
                    </td>
                    <td>
                      <Input
                        name={"cuff"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.cuff}
                        defaultChecked={form.cuff === "シングル"}
                      />
                      <Label>シングル</Label>
                      <Input
                        name={"cuff"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.cuff}
                        defaultChecked={form.cuff === "ダブル"}
                      />
                      <Label>ダブル</Label>
                      <Input
                        name={"cuff"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.cuff}
                        defaultChecked={form.cuff === "タタキ"}
                      />
                      <Label>タタキ</Label>
                    </td>
                    <td style={{ width: 55 }}>幅</td>
                    <td>
                      {/* <Label>幅</Label> */}
                      <TextInput
                        value={form.cuffRise || ""}
                        readOnly
                        name="cuffRise"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>膝幅</td>
                    <td>
                      <TextInput
                        value={form.kneeWidthAdjustment || ""}
                        readOnly
                        name="kneeWidthAdjustment"
                      />
                    </td>

                    <td>
                      <Input
                        name={"kneeWidth"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.kneeWidth}
                        defaultChecked={form.kneeWidth === "つめ"}
                      />
                      <Label>つめ</Label>
                      <Input
                        name={"kneeWidth"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.kneeWidth}
                        defaultChecked={form.kneeWidth === "出し"}
                      />
                      <Label>出し</Label>
                    </td>
                    <td style={{ width: 55 }}></td>
                    <td>
                      <TextInput
                        value={form.kneeWidthRise || ""}
                        readOnly
                        name="kneeWidthRise"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>裾幅</td>
                    <td>
                      <TextInput
                        value={form.hemWidthAdjustment || ""}
                        readOnly
                        name="hemWidthAdjustment"
                      />
                    </td>

                    <td>
                      <Input
                        name={"hemWidth"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.hemWidth}
                        defaultChecked={form.hemWidth === "つめ"}
                      />
                      <Label>つめ</Label>
                      <Input
                        name={"hemWidth"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.hemWidth}
                        defaultChecked={form.hemWidth === "出し"}
                      />
                      <Label>出し</Label>
                    </td>
                    <td style={{ width: 55 }}></td>
                    <td>
                      <TextInput
                        value={form.hemWidthRise || ""}
                        readOnly
                        name="hemWidthRise"
                      />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div>
              <h3>ジャケット</h3>
              <Table responsive style={{ whiteSpace: "nowrap" }}>
                <thead>
                  <tr>
                    <th>トラウザーズ</th>
                    <th>調整(cm)</th>
                    <th></th>
                    <th colSpan={2}>上がり（cm）</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ width: 150 }}>袖丈（右）</td>
                    <td style={{ width: 150 }}>
                      <TextInput
                        value={form.sleeveRightAdjustment || ""}
                        readOnly
                        name="sleeveRightAdjustment"
                      />
                    </td>
                    <td>
                      <Input
                        name={"sleeveRight"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.sleeveRight}
                        defaultChecked={form.sleeveRight === "つめ"}
                      />
                      <Label>つめ</Label>
                      <Input
                        name={"sleeveRight"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.sleeveRight}
                        defaultChecked={form.sleeveRight === "出し"}
                      />
                      <Label>出し</Label>
                    </td>
                    <td style={{ width: 55 }}></td>
                    <td style={{ width: 150 }}>
                      <TextInput
                        value={form.sleeveRightRise || ""}
                        readOnly
                        name="sleeveRightRise"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>袖丈（左）</td>
                    <td>
                      <TextInput
                        value={form.sleeveLeftAdjustment || ""}
                        readOnly
                        name="sleeveLeftAdjustment"
                      />
                    </td>

                    <td>
                      <Input
                        name={"sleeveLeft"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.sleeveLeft}
                        defaultChecked={form.sleeveLeft === "つめ"}
                      />
                      <Label>つめ</Label>
                      <Input
                        name={"sleeveLeft"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.sleeveLeft}
                        defaultChecked={form.sleeveLeft === "出し"}
                      />
                      <Label>出し</Label>
                    </td>
                    <td style={{ width: 55 }}></td>
                    <td>
                      <TextInput
                        value={form.sleeveLeftRise || ""}
                        readOnly
                        name="sleeveLeftRise"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>バスト</td>
                    <td>
                      <TextInput
                        value={form.bustAdjustment || ""}
                        readOnly
                        name="bustAdjustment"
                      />
                    </td>

                    <td>
                      <Input
                        name={"bust"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.bust}
                        defaultChecked={form.bust === "つめ"}
                      />
                      <Label>つめ</Label>
                      <Input
                        name={"bust"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.bust}
                        defaultChecked={form.bust === "出し"}
                      />
                      <Label>出し</Label>
                    </td>
                    <td style={{ width: 55 }}></td>
                    <td>
                      <TextInput
                        value={form.bustRise || ""}
                        readOnly
                        name="bustRise"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>ウエスト</td>
                    <td>
                      <TextInput
                        value={form.jacketWaistAdjustment || ""}
                        readOnly
                        name="jacketWaistAdjustment"
                      />
                    </td>

                    <td>
                      <Input
                        name={"jacketWaist"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.jacketWaist}
                        defaultChecked={form.jacketWaist === "つめ"}
                      />
                      <Label>つめ</Label>
                      <Input
                        name={"jacketWaist"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.jacketWaist}
                        defaultChecked={form.jacketWaist === "出し"}
                      />
                      <Label>出し</Label>
                    </td>
                    <td style={{ width: 55 }}></td>
                    <td>
                      <TextInput
                        value={form.jacketWaistRise || ""}
                        readOnly
                        name="jacketWaistRise"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>けまわし</td>
                    <td>
                      <TextInput
                        value={form.kemawashiAdjustment || ""}
                        readOnly
                        name="kemawashiAdjustment"
                      />
                    </td>

                    <td>
                      <Input
                        name={"kemawashi"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.kemawashi}
                        defaultChecked={form.kemawashi === "シングル"}
                      />
                      <Label>シングル</Label>
                      <Input
                        name={"kemawashi"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.kemawashi}
                        defaultChecked={form.kemawashi === "ダブル"}
                      />
                      <Label>ダブル</Label>
                      <Input
                        name={"kemawashi"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.kemawashi}
                        defaultChecked={form.kemawashi === "タタキ"}
                      />
                      <Label>タタキ</Label>
                    </td>
                    <td style={{ width: 55 }}>幅</td>
                    <td>
                      {/* <Label>幅</Label> */}
                      <TextInput
                        value={form.kemawashiRise || ""}
                        readOnly
                        name="kemawashiRise"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>膝幅</td>
                    <td>
                      <TextInput
                        value={form.lengthAdjustment || ""}
                        readOnly
                        name="lengthAdjustment"
                      />
                    </td>

                    <td>
                      <Input
                        name={"length"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.length}
                        defaultChecked={form.length === "つめ"}
                      />
                      <Label>つめ</Label>
                      <Input
                        name={"length"}
                        className="mx-4"
                        type="radio"
                        readOnly
                        value={form.length}
                        defaultChecked={form.length === "出し"}
                      />
                      <Label>出し</Label>
                    </td>
                    <td style={{ width: 55 }}></td>
                    <td>
                      <TextInput
                        value={form.lengthRise || ""}
                        readOnly
                        name="lengthRise"
                      />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
        {form?.payments && (
          <Row>
            <Col md={12}>
              <div>
                <Table responsive style={{ whiteSpace: "nowrap" }}>
                  <thead>
                    <tr>
                      <th>日付</th>
                      <th>入金方法</th>
                      <th>金額</th>
                    </tr>
                  </thead>
                  <tbody>
                    {form?.payments && form?.payments.length ? (
                      form?.payments.map((payment, index) => (
                        <tr key={index}>
                          <td>
                            {moment(payment.paymentDate).format("yyyy-MM-DD")}
                          </td>
                          <td>{payment.paymentMethodName}</td>
                          <td>{payment.amount}</td>
                        </tr>
                      ))
                    ) : (
                      <tr />
                    )}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        )}
      </ScrollBar>
    </Card>
  )
}

export default Repiar
